<template>
  <b-tab v-if="result.concepts" title="Extracted information" title-link-class="bg-info text-white">
    <b-card-text>
    <b-card-group columns>
    <b-card v-for="(card,index) in result.concepts" :key="'card'+index"
        :title="card.sem_title"
        class="card">

      <a v-on:click.prevent="openGraph(card.id, card.sem_title)" class="float-right" href="#"><b-icon icon="diagram-2" font-scale="2" variant="secondary"></b-icon></a>
      <dl>
        <dt v-if="card.sem_record_subtype">Subtype</dt>
        <dd v-if="card.sem_record_subtype">
          {{card.sem_record_subtype}}
        </dd>

        <dt v-if="card.id">ID</dt>
        <dd v-if="card.id">
          {{card.id}}
        </dd>

        <dt>URL</dt>
        <dd v-if="card.sem_url">
          <a :href="card.sem_url"  target="_blank">{{card.sem_url}}</a>
        </dd>

        <dt v-if="card.sem_abstract">Definition</dt>
        <dd v-if="card.sem_abstract">
          {{card.sem_abstract[0]}}
        </dd>

        <dt v-if="card.sem_title_synonyms">Synonyms</dt>
        <dd v-if="card.sem_title_synonyms">
          <span v-for="x in card.sem_title_synonyms" class="badge badge-light mr-1">{{ x | truncate(50, '...') }}</span>
        </dd>

        <img v-if="card.sem_image_url" :src="card.sem_image_url" />

      </dl>
    </b-card>
  </b-card-group>

<!--  <pre v-if="result.structured_concepts">{{result.structured_concepts}}</pre> -->


    </b-card-text>
  </b-tab>

</template>

<script>

export default {
  name: 'ExtractedInformation',
  props: ['result'],
  filters: {
    truncate: function (text, length, suffix) {
      if( text.length > length )
        return text.substring(0, length) + suffix;
      else
        return text;
    }
  },
  methods: {
    openGraph (nodeId, nodeTitle) {
       this.$router.push({ name: 'visualization', query: { id: nodeId }, params: { nodeTitle: nodeTitle } })
    }
  }
}
</script>

<style scoped>
</style>
